import ReactLoading from 'react-loading';

const PreLoader = () => {
  return <ReactLoading type="spinningBubbles"></ReactLoading>;
};

export default PreLoader;
